/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';

export class externaldatareference extends IceEntity {
	external_data_reference_key: string = "";
  external_data_key: string = "";
  trans_account: string = "";
  provider_trans_account: string = "";
  parent_src_type: number = 0;
  record_version: number = 0;
  offline_record_status: number = 0;

  gettablename(): string {
    return "EXTERNAL_DATA_REFERENCE";
  }
}
